import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ScreenContainer } from '@pinwheel/origami';
import ModalHeader from '../../components/ModalHeader';
import { initializeCardSwitch, next, selectDdsResponse, selectJobType, selectLinkApiResponse, waitForJobStepResults, } from '../../state/slices/slice-link-api';
import { useAppDispatch } from '../../state';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import LoadingView from '../../views/Loading';
import JobTemplate from '../../LinkApiRouter/views/JobTemplate';
import useIsLinkApiLoading from '../../hooks/useIsLinkApiLoading';
import { setError } from '../../state/slices/slice-error';
import useFireClientEvent from '../../hooks/useFireClientEvent';
import { useOpts } from '../../context';
var CardSwitch = function () {
    var dispatch = useAppDispatch();
    var navigate = useLinkNavigate();
    var linkApiResponse = useSelector(selectLinkApiResponse);
    var ddsResponse = useSelector(selectDdsResponse);
    var ddsOutcome = ddsResponse.responseType;
    var jobType = useSelector(selectJobType);
    var _a = useOpts(), featureFlags = _a.featureFlags, exit = _a.exit;
    var fireClientEvent = useFireClientEvent();
    useEffect(function () {
        fireClientEvent('card_switch_begin', {});
        void dispatch(initializeCardSwitch());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        if (jobType !== 'card_switch') {
            return;
        }
        if (!linkApiResponse)
            return;
        if (linkApiResponse.responseType === 'next')
            return;
        if (linkApiResponse.responseType === 'processing') {
            void dispatch(waitForJobStepResults());
        }
        else {
            // Send error client events
            if (ddsOutcome === 'pending_retry' || ddsOutcome === 'error') {
                dispatch(setError({
                    type: ddsResponse.error.type,
                    code: ddsResponse.error.code,
                    message: ddsResponse.error.message,
                    pendingRetry: ddsOutcome === 'pending_retry',
                }));
            }
            if (linkApiResponse.responseType === 'pending_retry' ||
                linkApiResponse.responseType === 'error') {
                dispatch(setError({
                    type: linkApiResponse.error.type,
                    code: linkApiResponse.error.code,
                    message: linkApiResponse.error.message,
                    pendingRetry: linkApiResponse.responseType === 'pending_retry',
                }));
            }
            // Navigate to combined outcome screen
            if (linkApiResponse.responseType === 'error' && ddsOutcome === 'error') {
                if (featureFlags.skipSuccessOrErrorTerminalScreen) {
                    exit();
                }
                else {
                    navigate('/error');
                }
            }
            else if (featureFlags.skipSuccessOrErrorTerminalScreen) {
                exit();
            }
            else if (linkApiResponse.responseType === 'pending_retry' ||
                ddsOutcome === 'pending_retry') {
                navigate('/error');
            }
            else if (linkApiResponse.responseType === 'success' &&
                ddsOutcome === 'success') {
                navigate('/card-switch/dds-card-success');
            }
            else if (linkApiResponse.responseType === 'success' &&
                ddsOutcome === 'error') {
                navigate('/card-switch/dds-error');
            }
            else if (linkApiResponse.responseType === 'error' &&
                ddsOutcome === 'success') {
                navigate('/card-switch/card-error');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkApiResponse]);
    var isLoading = useIsLinkApiLoading();
    var willRouteToError = linkApiResponse &&
        (linkApiResponse.responseType === 'error' ||
            linkApiResponse.responseType === 'pending_retry');
    return isLoading || willRouteToError ? (React.createElement(LoadingView, { hideModalHeader: true })) : (React.createElement(ScreenContainer, { "data-testid": "linkApi/card-switch" },
        React.createElement(ModalHeader, null),
        React.createElement(JobTemplate, { linkApiResponse: linkApiResponse, submitStep: function (payload) {
                return dispatch(next({
                    payload: payload,
                }));
            } })));
};
export default CardSwitch;
